import styled from 'styled-components';

export const Container = styled.div`
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-bottom: 2px solid var(--color-gray-900);

  .header {
    display: flex;
    gap: 10px;
    align-items: center;
    font-size: 12px;
    line-height: 15px;
    color: var(--color-navy-blue);

    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: 1;
    }

    .buttons {
      display: flex;
      gap: 8px;

      button {
        width: 24px;
        height: 24px;
        padding: 0px;
        align-self: flex-start;

        span {
          justify-content: center;
        }
      }

      button:nth-last-child(2) {
        background-color: var(--color-blue-opacity-10);
        color: var(--color-blue);
      }

      button:nth-last-child(2):hover {
        background-color: var(--color-blue-opacity-25);
      }

      button:last-child {
        background-color: var(--color-red-opacity-10);
        color: var(--color-red);
      }

      button:last-child:hover {
        background-color: var(--color-red-opacity-25);
      }
    }
  }

  .complements {
    margin-left: 14px;
    font-size: 12px;
    line-height: 15px;
    color: var(--color-alba-grandeza);
    display: flex;
    flex-direction: column;
    gap: 6px;

    .items {
      display: flex;
      align-items: center;
      gap: 10px;

      span:first-child {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      > div {
        border-bottom: 1px dashed var(--color-alba-grandeza);
        flex: 1;
        height: 0px;
      }
    }

    p {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
`;
